import { Injectable } from '@angular/core';
import { AdminContactsOpenerService } from './admin-contacts-opener.service';


@Injectable()
export class AdminContactsOpenerNeverService extends AdminContactsOpenerService {
    openIfNeeded(): void {}
}
